import article from './articles/articleReducer';
import articleList from './articles/articleList/reducer';
import communityAbout from './community/communityAbout/reducer';
import communityHome from './community/communityHome/reducer';
import communityPosts from './community/communityPosts/reducer';
import editProfile from './user/editProfile/reducer';
import home from './home/reducer';
import local from './local/reducer';
import needsAssessmentList from './needsAssessment/needsAssessmentList/reducer';
import needsAssessmentReport from './needsAssessment/needsAssessmentReport/reducer';
import programs from './programs/reducer';
import search from './search/shared/reducer';
import poll from 'src/pages/community/poll/reducer';
import post from './community/singlePost/reducer';
import tag from 'src/pages/tag/reducer';
import tagsList from './tagsList/reducer';

const reduceReducers = (...reducers) => (state, action) => reducers.reduce((acc, r) => r(acc, action), state);

const pageReducers = {
  article,
  articleList,
  communityAbout,
  communityHome,
  communityPosts,
  editProfile,
  home,
  local,
  needsAssessmentList,
  needsAssessmentReport,
  programs,
  search,
  singlePost: reduceReducers(post, poll),
  tag,
  tagsList,
};

export default pageReducers;
